import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthRoutingModule } from './auth-routing.module';
import { AuthService } from './auth.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthRequestInterceptor } from './auth-request.interceptor';
import { AuthResponseInterceptor } from './auth-response.interceptor';
import { TranslateModule } from '@ngx-translate/core';

/** Http interceptor providers in outside-in order */
export const AUTH_HTTP_INTERCEPTOR_PROVIDERS = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthRequestInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: AuthResponseInterceptor, multi: true },
];

@NgModule({
  declarations: [],
  providers: [AuthService],
  exports: [],
  imports: [
    CommonModule,
    AuthRoutingModule,
    TranslateModule.forChild()
  ]

})
export class AuthModule { }
